// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c2-b";
export var colorBlue = "_c2-8";
export var colorDot = "_c2-0";
export var colorDotLarge = "_c2-2";
export var colorDotSmall = "_c2-1";
export var colorGreen = "_c2-7";
export var colorGrey = "_c2-3";
export var colorOrange = "_c2-5";
export var colorPink = "_c2-a";
export var colorPurple = "_c2-9";
export var colorRed = "_c2-4";
export var colorYellow = "_c2-6";